import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MediaComponent } from './media/media.component';
import { AuthGuard } from '../../_helper/auth.guard';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: MediaComponent,
        data: {
          title: "Media",
          breadcrumb: "Media"
        },
        canActivate: [AuthGuard],
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MediaRoutingModule { }
